import React, { useEffect, useState } from 'react'
import Error404 from 'components/Error404';
import { BASE_HEADER, BASE_URL_JAVAZ_API, BASE_URL_MAPS_MONITORING, BASE_URL_OSLOG } from '../../../constants/ActionTypes';
import axios from 'axios';


const EmbeddMapMonitoringV2 = () => {
    const [URL, setURL] = useState('');
    // const [URL, setURL] = useState(`http://siopas.co.id`);
    const [height, setHeight] = useState(null);
    const [width, setWidth] = useState('100%');

    const checkRequest = async(companyId) => {
        try {
            await axios.get(`${BASE_URL_JAVAZ_API}/company/${companyId}`, BASE_HEADER)
            return true
        } catch (error) {
            if (error.response.data.code === 401) {
                refreshToken(companyId)           
            }
        }
        return true
    }

    const refreshToken = async(companyId) => {
        const response = await axios.get(`${BASE_URL_JAVAZ_API}/user/refresh-token/${companyId}`)
        if (response.data.code === 200) {
            const result = response.data.data
            // setURL(`${BASE_URL_OSLOG}/embedd-maps-monitoring?apiKey=${result.apikey}&apikey_jyoti=${result.apikey_jyoti}&c=${result.company}&uid=${result.id}`)
            setURL(`${BASE_URL_MAPS_MONITORING}?apiKey=${result.apikey}&apikey_jyoti=${result.apikey_jyoti}&c=${result.company}&uid=${result.id}`)
        }
    }

    useEffect(() => {
        const COMPANY_ID = localStorage.getItem('companyId');
        const APIKEY_JYOTI = localStorage.getItem('apikey_jyoti');
        const APIKEY_JAVAZ = localStorage.getItem('apiKey');
        const USER_ID = localStorage.getItem('user_id');
        const headerHeight = document.getElementById('app-header').clientHeight;
        const bodyHeight = document.body.clientHeight;
        const check = checkRequest(COMPANY_ID)
        if (check) {
            // setURL(`${BASE_URL_OSLOG}/embedd-maps-monitoring?apiKey=${APIKEY_JAVAZ}&apikey_jyoti=${APIKEY_JYOTI}&c=${COMPANY_ID}&uid=${USER_ID}`)
            setURL(`${BASE_URL_MAPS_MONITORING}?apiKey=${APIKEY_JAVAZ}&apikey_jyoti=${APIKEY_JYOTI}&c=${COMPANY_ID}&uid=${USER_ID}`)
        }
        const init = bodyHeight - headerHeight;
        const height = init - 5;
        setHeight(height);
    }, [])

    return (
        <div>
            {
                height !== null && width !== null ?
                <iframe 
                    id="frame-embedd" 
                    src={URL}
                    style={{
                        width: width,
                        height: `${height}px`,
                    }}
                    scrolling="no" 
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
                :
                <Error404 />
            }
        </div>
    )
}

export default EmbeddMapMonitoringV2;


// WEBPACK FOOTER //
// ./app/routes/EmbeddMapMonitoringV2/index.js